export const REDUX_MAP_TYPES = {
  SELECTED_DISTANCE: 'MAP_SELECTED_DISTANCE',
  ROUTE_SELECTABLE: 'MAP_ROUTE_SELECTABLE',
  SELECTED_ROUTE: 'MAP_SELECTED_ROUTE',
  MAP_FORM: 'MAP_FORM',
  EDIT_MODE: 'MAP_EDIT_ON',
  RESET: 'MAP_RESET'
}

export const dispatchSelectedDistance = (data) => (dispatch) => dispatch({
  type: REDUX_MAP_TYPES.SELECTED_DISTANCE,
  payload: data
})

export const dispatchMapReset = (data) => (dispatch) => dispatch({
  type: REDUX_MAP_TYPES.RESET,
  payload: data
})

export const dispatchRouteSelectable = (data) => (dispatch) => dispatch({
  type: REDUX_MAP_TYPES.ROUTE_SELECTABLE,
  payload: data
})

export const dispatchSelectedRoute = (data) => (dispatch) => dispatch({
  type: REDUX_MAP_TYPES.SELECTED_ROUTE,
  payload: data
})

export const dispatchMapForm = (form) => (dispatch) => dispatch({
  type: REDUX_MAP_TYPES.MAP_FORM,
  payload: form
})

export const dispatchMapEditMode = (on) => (dispatch) => dispatch({
  type: REDUX_MAP_TYPES.EDIT_MODE,
  payload: on
})
